/**
 * Gorilla Netting storefront helpers.
 * Warehouse theme: patch ITORIS DPO price selectors so updatePrice() can write totals.
 * Fix 2026-08-10: ATC lives outside form[action*="cart/add"] (in <buy-button>);
 * Deploy stamp: 2026-08-25-native-atc-product-added
 * patch DPO button selectors, ensure [dpo_add2cart], theme cart guard — no ITORIS redeploy.
 *
 * Premade strip 2026-08-10: fixed-size products tagged "premade" must never show the CTO
 * dimension calculator. ITORIS still has mis-applied configs for some JFN premade SKUs;
 * strip the UI/client until those configs are deleted in the DPO admin.
 * Repair kit 2026-08-24: netting-repair-mend-kit is a fixed accessory, not cut-to-order.
 */
(function () {
  'use strict';

  var WAREHOUSE_PRICE =
    '[data-section-type="product"] .product-form__info-list .price-list .price, ' +
    '.product-form__info-list .price-list .price, ' +
    '.product-form__info-content .price, ' +
    '.product-form .price-list .price, ' +
    '.shopify-section--main-product .price-list .price';
  var WAREHOUSE_COMPARE =
    '[data-section-type="product"] .product-form__info-list .price-list .price--compare, ' +
    '.product-form__info-list .price-list .price--compare, ' +
    '.product-form .price-list .price--compare, ' +
    '.shopify-section--main-product .price-list .price--compare';
  var WAREHOUSE_PRICE_BOX =
    '[data-section-type="product"] .product-form__info-list .price-list, ' +
    '.product-form__info-list .price-list, ' +
    '.product-form .price-list, ' +
    '.shopify-section--main-product .price-list';

  // Warehouse puts ATC outside form[action*="cart/add"] (inside <buy-button>).
  var WAREHOUSE_SUBMIT_BTN =
    'buy-button.buy-button .product-form__add-button, buy-button .product-form__add-button, ' +
    '.product-form__buy-buttons .product-form__add-button, .product-form__payment-container .product-form__add-button, ' +
    '.product-form__add-button';
  var WAREHOUSE_ATC_FIND = WAREHOUSE_SUBMIT_BTN;
  var WAREHOUSE_ATC_CLICK =
    WAREHOUSE_SUBMIT_BTN + ', buy-button.buy-button';

  var RETRY_MS = [0, 500, 1500, 3000, 6000];
  var GUARD_ATTR = 'data-gn-warehouse-cart-guard-theme';
  var PREMADE_STRIP_ATTR = 'data-gn-dpo-stripped';

  function asDpoButtonRef(el) {
    if (!el) {
      return null;
    }
    return window.jQuery ? jQuery(el) : el;
  }

  // Known mis-applied ITORIS CTO configs (premade fixed-size). Tags may be missing from meta.product.
  var GN_PREMADE_PRODUCT_IDS = {
    '10727070892342': 1, // dynamax collegiate soccer goal net pair
    '10727072432438': 1, // dynamax pickleball net tournament
    '10727072563510': 1, // dynamax tournament soccer goal net each
    '8690082021686': 1, // netting repair / mending kit
  };
  var GN_PREMADE_HANDLES = {
    'dynamax-sports-collegiate-soccer-goal-net-8h-x-24w-x-4t-x-8d-pair': 1,
    'dynamax-sports-pickleball-net-tournament-series-36-high': 1,
    'dynamax-sports-tournament-soccer-goal-net-8h-x-24w-x-4t-x-8d-each': 1,
    'netting-repair-mend-kit': 1,
  };
  var GN_STRIP_DPO_TAGS = ['premade', 'repair kit', 'net mending'];

  function gnProductTagsLower() {
    var tags = [];
    try {
      if (window.gnProductTags != null) {
        if (typeof window.gnProductTags === 'string') {
          tags = window.gnProductTags.split(',');
        } else if (window.gnProductTags.length != null) {
          tags = Array.prototype.slice.call(window.gnProductTags);
        }
      } else if (window.meta && meta.product && meta.product.tags != null) {
        if (typeof meta.product.tags === 'string') {
          tags = meta.product.tags.split(',');
        } else if (meta.product.tags.length != null) {
          tags = Array.prototype.slice.call(meta.product.tags);
        }
      }
    } catch (e) {
      /* ignore */
    }
    return tags.map(function (t) {
      return String(t).trim().toLowerCase();
    });
  }

  function gnProductId() {
    try {
      if (window.meta && meta.product && meta.product.id) {
        return String(meta.product.id);
      }
    } catch (e) {
      /* ignore */
    }
    return '';
  }

  function gnProductHandle() {
    try {
      if (window.meta && meta.product && meta.product.handle) {
        return String(meta.product.handle);
      }
    } catch (e) {
      /* ignore */
    }
    try {
      var m = (location.pathname || '').match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e2) {
      return '';
    }
  }

  // KEEP: cut-to-order netting only. Everything else on a PDP strips DPO.
  var GN_KEEP_DPO_IDS = {
    '8690081038646': 1,
    '8690081268022': 1,
    '8690081366326': 1,
    '8690081562934': 1,
    '8690081726774': 1,
    '8690083791158': 1,
    '8690084184374': 1,
    '8690084544822': 1,
    '8690084806966': 1,
    '8690084970806': 1,
    '8690085298486': 1,
    '8690085527862': 1,
    '8690087133494': 1,
    '10727071154486': 1,
    '10727071482166': 1,
    '10727071678774': 1,
    '10727072825654': 1,
    '10727075348790': 1,
    '10727087571254': 1,
    '10727087702326': 1,
    '10727087866166': 1
  };
  var GN_KEEP_DPO_HANDLES = {
    '30-1-1-2-knotted-nylon-netting': 1,
    '18-1-mesh-nylon-golf-barrier-net': 1,
    '18-high-impact-nylon-golf-netting': 1,
    '24-knotted-nylon-high-impact-golf-netting': 1,
    '36-4-knotted-nylon-netting': 1,
    '18-1-7-8-knotted-nylon-netting-cut-to-order': 1,
    '21-1-7-8-knotted-nylon-netting-cut-to-order': 1,
    '36-1-7-8-knotted-nylon-netting': 1,
    '42-1-7-8-knotted-nylon-netting-cut-to-order': 1,
    '48-1-7-8-knotted-nylon-netting-cut-to-order': 1,
    '60-1-7-8-knotted-nylon-netting-cut-to-order': 1,
    '96-1-7-8-knotted-nylon-netting-cut-to-order': 1,
    '18-7-8-knotless-polyester-netting': 1,
    '30-nylon-lacrosse-hockey-backstop-net-custom-size': 1,
    'drone-uav-enclosure-cage-polyethylene-nets-10x10x10': 1,
    'drone-uav-safety-polyethylene-nets-custom-size': 1,
    'industrial-netsagriculture-netsheavy-duty-polyethylene-bird-uv-netting-custo': 1,
    '9mm-monofilament-hockey-barrier-net-custom-size': 1,
    '24-1-7-8-knotted-nylon-netting-cut-to-order': 1,
    '72-1-7-8-knotted-nylon-netting-cut-to-order': 1,
    '18-1-7-8-knotted-polyethylene-netting-cut-to-order': 1
  };

  /** Hide DPO unless this is KEEP cut-to-order netting. */
  function gnIsPremadeFixedProduct() {
    if (!/\/products\//.test(location.pathname || '')) {
      return false;
    }
    if (GN_KEEP_DPO_IDS[gnProductId()] || GN_KEEP_DPO_HANDLES[gnProductHandle()]) {
      return false;
    }
    var tags = gnProductTagsLower();
    var i;
    for (i = 0; i < GN_STRIP_DPO_TAGS.length; i++) {
      if (tags.indexOf(GN_STRIP_DPO_TAGS[i]) !== -1) {
        return true;
      }
    }
    if (GN_PREMADE_PRODUCT_IDS[gnProductId()] || GN_PREMADE_HANDLES[gnProductHandle()]) {
      return true;
    }
    return true;
  }

  /**
   * Remove mis-applied ITORIS CTO calculator from premade PDPs.
   * Returns true when strip mode is active for this product.
   */
  function gnStripMisappliedDpo() {
    if (!gnIsPremadeFixedProduct()) {
      return false;
    }
    var ids = [
      'itoris_dynamicproductoptions',
      'itoris_dynamicproductoptions_popup',
      'itoris_dynamicproductoptions_popup_mask',
      'itoris_dynamicproductoptions_add_to_cart_configure',
      'itoris_dynamicproductoptions_configuration',
    ];
    var i;
    for (i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
    try {
      var leftovers = document.querySelectorAll(
        '#itoris_dynamicproductoptions, .dpo-container, [id^="itoris_dynamicproductoptions"]'
      );
      for (i = 0; i < leftovers.length; i++) {
        if (leftovers[i].parentNode) {
          leftovers[i].parentNode.removeChild(leftovers[i]);
        }
      }
    } catch (e) {
      /* ignore */
    }
    try {
      if (window.dpoOptions) {
        dpoOptions.skipVariantCreation = true;
        if (typeof dpoOptions.addToCart === 'function') {
          dpoOptions.addToCart = function () {
            gnSubmitNativeProductForm();
            return true;
          };
        }
      }
      if (window.PriceFormula) {
        PriceFormula.formulas = [];
      }
    } catch (e2) {
      /* ignore */
    }
    gnRestoreNativeAtc();
    document.documentElement.setAttribute(PREMADE_STRIP_ATTR, 'premade');
    return true;
  }

  /** Keep theme ATC enabled after DPO is stripped (do not clone — that drops theme handlers). */
  function gnRestoreNativeAtc() {
    try {
      var nodes = document.querySelectorAll(WAREHOUSE_ATC_FIND);
      var i;
      for (i = 0; i < nodes.length; i++) {
        nodes[i].disabled = false;
        nodes[i].removeAttribute('disabled');
      }
    } catch (e) {
      /* ignore */
    }
  }

  function gnSubmitNativeProductForm(ev) {
    try {
      if (gnSubmitNativeProductForm.busy) {
        return;
      }
      var btn =
        ev && ev.target && ev.target.closest
          ? ev.target.closest(WAREHOUSE_ATC_CLICK)
          : document.querySelector(WAREHOUSE_ATC_FIND);
      var section =
        document.querySelector('.shopify-section--main-product') ||
        document.querySelector('[id^="shopify-section-template"]') ||
        document;
      var idEl = section.querySelector(
        'select[name="id"], input.product-form__variant-id, input[name="id"], buy-button [name="id"]'
      );
      if (!idEl) {
        idEl = document.querySelector(
          '.product-form select[name="id"], .product-form [name="id"], input[name="id"]'
        );
      }
      var qtyEl = section.querySelector(
        'input[name="quantity"], .quantity-selector__input, .product-form__quantity input, .quantity-selector__value'
      );
      var variantId = window.gnSelectedVariantId || (idEl && idEl.value);
      var qty = Number((qtyEl && qtyEl.value) || 1) || 1;
      if (!variantId) {
        return;
      }
      gnSubmitNativeProductForm.busy = true;
      if (btn) {
        btn.setAttribute('disabled', 'disabled');
      }
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: qty,
        }),
      })
        .then(function (res) {
          var added = new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              button: btn,
              variant: null,
              quantity: qty,
              productAdded: !!res.ok,
            },
          });
          document.documentElement.dispatchEvent(added);
          if (!res.ok) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          }
        })
        .catch(function () {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        })
        .then(function () {
          gnSubmitNativeProductForm.busy = false;
          if (btn) {
            btn.removeAttribute('disabled');
          }
          gnRestoreNativeAtc();
        });
    } catch (e) {
      gnSubmitNativeProductForm.busy = false;
      gnRestoreNativeAtc();
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }
  }

  function gnPatchDpoPriceSelectors() {
    if (!window.dpoObserver || !dpoObserver.selectors) {
      return false;
    }
    var s = dpoObserver.selectors;
    if (s.specialPrice.indexOf('price-list') !== -1) {
      return true;
    }
    s.specialPrice = WAREHOUSE_PRICE + ', ' + s.specialPrice;
    s.regularPrice = WAREHOUSE_COMPARE + ', ' + s.regularPrice;
    s.priceBox = WAREHOUSE_PRICE_BOX + ', ' + s.priceBox;
    return true;
  }

  /**
   * Expand ITORIS submitBtn / submitBtnContainer so Warehouse <buy-button> ATC is found.
   */
  function gnPatchDpoButtonSelectors() {
    if (!window.dpoObserver || !dpoObserver.selectors) {
      return false;
    }
    var s = dpoObserver.selectors;
    var patched = false;
    if (s.submitBtn && s.submitBtn.indexOf('buy-button.buy-button') === -1) {
      s.submitBtn = WAREHOUSE_SUBMIT_BTN + ', ' + s.submitBtn;
      patched = true;
    }
    if (s.submitBtnContainer && s.submitBtnContainer.indexOf('buy-button.buy-button') === -1) {
      s.submitBtnContainer = WAREHOUSE_SUBMIT_BTN + ', ' + s.submitBtnContainer;
      patched = true;
    }
    return patched || !!(s.submitBtn && s.submitBtn.indexOf('buy-button.buy-button') !== -1);
  }

  function gnPatchDpoSelectors() {
    var priceOk = gnPatchDpoPriceSelectors();
    var btnOk = gnPatchDpoButtonSelectors();
    return priceOk || btnOk;
  }

  /**
   * Warehouse ATC is outside form[action*="cart/add"], so ITORIS may never create [dpo_add2cart].
   * Clone native ATC ITORIS-style when missing so addToCart / cart guard can run.
   */
  function gnDpoHasUsableCalculator() {
    if (gnIsPremadeFixedProduct()) {
      return false;
    }
    var root = document.getElementById('itoris_dynamicproductoptions');
    if (!root || !window.dpoOptions) {
      return false;
    }
    var fields = root.querySelectorAll('input, select, textarea');
    return fields.length > 0;
  }

  function gnEnsureDpoAddToCartButton() {
    if (!gnDpoHasUsableCalculator()) {
      return null;
    }

    var existing = document.querySelector('[dpo_add2cart]');
    if (existing) {
      dpoOptions.addToCartButton = asDpoButtonRef(existing);
      return existing;
    }

    gnPatchDpoButtonSelectors();

    var nativeBtn = document.querySelector(WAREHOUSE_ATC_FIND);
    if (!nativeBtn) {
      return null;
    }

    var clone = nativeBtn.cloneNode(true);
    clone.setAttribute('dpo_add2cart', '1');
    clone.setAttribute('onclick', 'return window.dpoOptions.addToCart(this, event)');
    if (nativeBtn.parentNode) {
      nativeBtn.parentNode.insertBefore(clone, nativeBtn.nextSibling);
    }
    nativeBtn.style.display = 'none';
    nativeBtn.style.visibility = 'hidden';
    dpoOptions.prevAddToCartButton = asDpoButtonRef(nativeBtn);
    dpoOptions.addToCartButton = asDpoButtonRef(clone);
    return clone;
  }

  function gnForceDpoPriceRefresh() {
    if (typeof window.gnRefreshDpoPrice === 'function') {
      window.gnRefreshDpoPrice();
      return;
    }
    if (!gnPatchDpoPriceSelectors()) {
      return;
    }
    if (!window.dpoOptions || typeof dpoOptions.updatePrice !== 'function') {
      return;
    }
    var dpoElm = document.getElementById('itoris_dynamicproductoptions');
    if (dpoElm) {
      dpoElm.dpoProductInitialPrices = false;
    }
    dpoOptions.lastUpdatePriceResult = false;
    dpoOptions.updatePrice(true);
  }

  /**
   * Warehouse color swatches often leave the first [name=id] on the default (Black)
   * even when White is selected. ITORIS parents the ATC D# ghost on that id.
   * Resolve the visible Black/White swatch and write the matching BASE variant id
   * (never a D# ghost) onto every relevant id field before DPO addToCart.
   */
  var GN_BASE_COLOR_SYNC_ATTR = 'data-gn-base-color-sync';

  function gnTrimText(text) {
    return String(text == null ? '' : text).replace(/^\s+|\s+$/g, '');
  }

  function gnTextHasDpoGhost(text) {
    return gnTrimText(text).indexOf('(D#') !== -1;
  }

  function gnExactBaseColorName(text) {
    var t = gnTrimText(text);
    if (!t || gnTextHasDpoGhost(t)) {
      return '';
    }
    if (t.toLowerCase() === 'black') {
      return 'Black';
    }
    if (t.toLowerCase() === 'white') {
      return 'White';
    }
    return '';
  }

  function gnLooseBaseColorName(text) {
    var exact = gnExactBaseColorName(text);
    if (exact) {
      return exact;
    }
    var t = gnTrimText(text);
    if (!t || gnTextHasDpoGhost(t)) {
      return '';
    }
    if (/^black(\s|$|[-–—/,])/i.test(t)) {
      return 'Black';
    }
    if (/^white(\s|$|[-–—/,])/i.test(t)) {
      return 'White';
    }
    var end = t.match(/[-–—]\s*(black|white)\s*$/i);
    if (end) {
      return end[1].charAt(0).toUpperCase() + end[1].slice(1).toLowerCase();
    }
    return '';
  }

  function gnGetProductVariants() {
    var out = [];
    var seen = {};
    function pushList(list) {
      if (!list || !list.length) {
        return;
      }
      var i;
      var v;
      var id;
      for (i = 0; i < list.length; i++) {
        v = list[i];
        if (!v) {
          continue;
        }
        id = String(v.id || '');
        if (!id || seen[id]) {
          continue;
        }
        seen[id] = 1;
        out.push(v);
      }
    }
    try {
      if (window.meta && meta.product && meta.product.variants) {
        pushList(meta.product.variants);
      }
    } catch (e) {
      /* ignore */
    }
    try {
      if (
        window.ShopifyAnalytics &&
        ShopifyAnalytics.meta &&
        ShopifyAnalytics.meta.product &&
        ShopifyAnalytics.meta.product.variants
      ) {
        pushList(ShopifyAnalytics.meta.product.variants);
      }
    } catch (e2) {
      /* ignore */
    }
    try {
      if (window.estimatedProductVariants && estimatedProductVariants.length) {
        pushList(estimatedProductVariants);
      }
    } catch (e3) {
      /* ignore */
    }
    try {
      if (
        window.estimatedCurrentProduct &&
        estimatedCurrentProduct.variants &&
        estimatedCurrentProduct.variants.length
      ) {
        pushList(estimatedCurrentProduct.variants);
      }
    } catch (e4) {
      /* ignore */
    }
    return out;
  }

  function gnVariantBaseColor(variant) {
    if (!variant) {
      return '';
    }
    var fields = [variant.title, variant.public_title, variant.option1];
    var i;
    var raw;
    var color;
    for (i = 0; i < fields.length; i++) {
      raw = gnTrimText(fields[i]);
      if (!raw) {
        continue;
      }
      if (gnTextHasDpoGhost(raw)) {
        return '';
      }
      color = gnExactBaseColorName(raw);
      if (color) {
        return color;
      }
    }
    raw = gnTrimText(variant.name);
    if (raw && gnTextHasDpoGhost(raw)) {
      return '';
    }
    return gnLooseBaseColorName(raw);
  }

  function gnFindBaseVariantIdForColor(color) {
    if (!color) {
      return '';
    }
    var variants = gnGetProductVariants();
    var i;
    var v;
    var id;
    for (i = 0; i < variants.length; i++) {
      v = variants[i];
      if (gnVariantBaseColor(v) !== color) {
        continue;
      }
      id = String(v.id || '');
      if (!id) {
        continue;
      }
      return id;
    }
    var root =
      document.querySelector('.shopify-section--main-product') ||
      document;
    var opts = root.querySelectorAll('select[name="id"] option');
    var optText;
    for (i = 0; i < opts.length; i++) {
      optText = gnTrimText(opts[i].text);
      if (gnTextHasDpoGhost(optText)) {
        continue;
      }
      if (gnExactBaseColorName(optText) === color || gnLooseBaseColorName(optText) === color) {
        id = String(opts[i].value || '');
        if (id) {
          return id;
        }
      }
    }
    return '';
  }

  function gnColorFromRadio(radio) {
    if (!radio) {
      return '';
    }
    var label = null;
    if (radio.id) {
      try {
        label = document.querySelector('label[for="' + radio.id + '"]');
      } catch (e) {
        label = null;
      }
    }
    if (!label && radio.nextElementSibling && radio.nextElementSibling.tagName === 'LABEL') {
      label = radio.nextElementSibling;
    }
    if (!label && radio.closest) {
      var wrap = radio.closest('.block-swatch') || radio.closest('label');
      if (wrap) {
        label = wrap.tagName === 'LABEL' ? wrap : wrap.querySelector('label.block-swatch__item, label');
      }
    }
    if (!label) {
      return '';
    }
    var title = gnTrimText(label.getAttribute && label.getAttribute('title'));
    var span = label.querySelector && label.querySelector('.block-swatch__item-text');
    var text = gnTrimText((span && span.textContent) || label.textContent);
    if (gnTextHasDpoGhost(title) || gnTextHasDpoGhost(text)) {
      return '';
    }
    return gnExactBaseColorName(title) || gnExactBaseColorName(text);
  }

  function gnResolveSelectedBaseColor() {
    var root =
      document.querySelector('.shopify-section--main-product') ||
      document.querySelector('[id^="shopify-section-template"]') ||
      document;
    var radios = root.querySelectorAll(
      'input.block-swatch__radio:checked, variant-picker input[type="radio"]:checked'
    );
    var i;
    var color;
    for (i = 0; i < radios.length; i++) {
      color = gnColorFromRadio(radios[i]);
      if (color) {
        return color;
      }
    }
    var values = root.querySelectorAll('.product-form__selected-value');
    for (i = 0; i < values.length; i++) {
      color = gnExactBaseColorName(values[i].textContent);
      if (color) {
        return color;
      }
    }
    var selects = root.querySelectorAll('select[name="id"]');
    var opt;
    for (i = 0; i < selects.length; i++) {
      opt = selects[i].options[selects[i].selectedIndex];
      if (!opt) {
        continue;
      }
      if (gnTextHasDpoGhost(opt.text) || gnTextHasDpoGhost(opt.getAttribute('title'))) {
        continue;
      }
      color =
        gnExactBaseColorName(opt.getAttribute('title')) ||
        gnExactBaseColorName(opt.text) ||
        gnLooseBaseColorName(opt.text);
      if (color) {
        return color;
      }
    }
    return '';
  }

  function gnResolveSelectedBaseVariantId() {
    return gnFindBaseVariantIdForColor(gnResolveSelectedBaseColor());
  }

  function gnSelectHasOptionValue(select, id) {
    if (!select || !select.options) {
      return false;
    }
    var i;
    for (i = 0; i < select.options.length; i++) {
      if (String(select.options[i].value) === String(id)) {
        return true;
      }
    }
    return false;
  }

  function gnEnsureSelectOption(select, id, color) {
    if (!select || gnSelectHasOptionValue(select, id)) {
      return;
    }
    var opt = document.createElement('option');
    opt.value = String(id);
    opt.text = color || String(id);
    select.appendChild(opt);
  }

  function gnTriggerSelectChange(select) {
    try {
      if (window.jQuery) {
        jQuery(select).val(select.value).trigger('change');
      } else if (typeof Event === 'function') {
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } catch (e) {
      /* ignore */
    }
  }

  function gnSyncBaseColorVariantToForm(skipChangeEvent) {
    if (window.gnBaseColorSyncing) {
      return window.gnSyncedBaseVariantId || '';
    }
    var color = gnResolveSelectedBaseColor();
    var id = gnResolveSelectedBaseVariantId();
    if (!id) {
      return '';
    }
    window.gnBaseColorSyncing = true;
    window.gnSyncedBaseVariantId = id;
    try {
      var nodes = document.querySelectorAll(
        'select[name="id"], input[name="id"], input.product-form__variant-id, buy-button [name="id"]'
      );
      var i;
      var el;
      var changedSelect = null;
      for (i = 0; i < nodes.length; i++) {
        el = nodes[i];
        if (!el) {
          continue;
        }
        if (el.tagName === 'SELECT') {
          gnEnsureSelectOption(el, id, color);
          if (String(el.value) !== String(id)) {
            el.value = String(id);
            if (!changedSelect) {
              changedSelect = el;
            }
          }
        } else if (String(el.value) !== String(id)) {
          el.value = String(id);
        }
      }
      if (changedSelect && !skipChangeEvent) {
        gnTriggerSelectChange(changedSelect);
      }
      try {
        if (window.dpoObserver && dpoObserver.selectors && dpoObserver.selectors.variantId && window.jQuery) {
          jQuery(dpoObserver.selectors.variantId).each(function () {
            if (this.tagName === 'SELECT') {
              gnEnsureSelectOption(this, id, color);
            }
            if (String(this.value) !== String(id)) {
              this.value = String(id);
            }
          });
        }
      } catch (eSel) {
        /* ignore */
      }
      try {
        if (window.dpoObserver) {
          dpoObserver.variantId = id;
          var variants = gnGetProductVariants();
          var v = null;
          for (i = 0; i < variants.length; i++) {
            if (String(variants[i].id) === String(id)) {
              v = variants[i];
              break;
            }
          }
          if (v) {
            dpoObserver.variantObj = v;
          } else if (typeof dpoObserver.getVariant === 'function') {
            v = dpoObserver.getVariant(id);
            if (v) {
              dpoObserver.variantObj = v;
            }
          }
        }
      } catch (eObs) {
        /* ignore */
      }
    } finally {
      window.gnBaseColorSyncing = false;
    }
    return id;
  }

  function gnBindBaseColorVariantSyncTheme() {
    if (document.documentElement.getAttribute(GN_BASE_COLOR_SYNC_ATTR)) {
      return;
    }
    document.documentElement.setAttribute(GN_BASE_COLOR_SYNC_ATTR, '1');
    document.addEventListener(
      'change',
      function (ev) {
        var t = ev.target;
        if (!t || !t.matches) {
          return;
        }
        if (!t.matches('input.block-swatch__radio, variant-picker input[type="radio"]')) {
          return;
        }
        if (gnIsPremadeFixedProduct() || !gnDpoHasUsableCalculator()) {
          return;
        }
        setTimeout(function () {
          gnSyncBaseColorVariantToForm();
        }, 50);
      },
      true
    );
  }

  /**
   * Capture-phase guard: Warehouse ATC lives outside form[action*="cart/add"].
   * Native BuyButton then throws (null.elements) and the button spinner hangs.
   * Route CTO (real DPO fields) through ITORIS; everything else through /cart/add.js.
   */
  function gnBindWarehouseCartGuardTheme() {
    if (document.documentElement.getAttribute(GUARD_ATTR)) {
      return;
    }
    document.documentElement.setAttribute(GUARD_ATTR, '1');

    function isWarehouseAtc(ev) {
      if (ev.target.closest && ev.target.closest('[data-shopify="payment-button"], shopify-accelerated-checkout')) {
        return null;
      }
      return ev.target.closest && ev.target.closest(WAREHOUSE_ATC_CLICK);
    }

    function routeAtc(ev) {
      var submitBtn = isWarehouseAtc(ev);
      if (!submitBtn) {
        return false;
      }
      if (gnDpoHasUsableCalculator()) {
        if (ev.target.closest && ev.target.closest('[dpo_add2cart]')) {
          return false;
        }
        if (submitBtn.getAttribute && submitBtn.getAttribute('dpo_add2cart')) {
          return false;
        }
        var dpoBtn = gnEnsureDpoAddToCartButton();
        if (dpoBtn && window.dpoOptions && typeof dpoOptions.addToCart === 'function') {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          gnSyncBaseColorVariantToForm(true);
          dpoOptions.addToCart(dpoBtn, ev);
          return true;
        }
      }
      ev.preventDefault();
      ev.stopImmediatePropagation();
      gnSubmitNativeProductForm(ev);
      return true;
    }

    document.addEventListener(
      'click',
      function (ev) {
        routeAtc(ev);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (ev) {
        var form = ev.target;
        if (!form || !form.getAttribute) {
          return;
        }
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1 && action.indexOf('cart/add') === -1) {
          return;
        }
        routeAtc(ev);
      },
      true
    );
  }

  function gnOnDpoBeforeInitialize() {
    if (gnStripMisappliedDpo()) {
      return;
    }
    gnPatchDpoSelectors();
  }

  function gnOnDpoInitialized() {
    if (gnStripMisappliedDpo()) {
      return;
    }
    gnPatchDpoSelectors();
    gnEnsureDpoAddToCartButton();
    gnBindWarehouseCartGuardTheme();
    gnBindBaseColorVariantSyncTheme();
    gnForceDpoPriceRefresh();
  }

  function gnScheduleLatePaintRetries() {
    RETRY_MS.forEach(function (ms) {
      setTimeout(function () {
        if (gnStripMisappliedDpo()) {
          return;
        }
        gnPatchDpoSelectors();
        gnEnsureDpoAddToCartButton();
        gnBindWarehouseCartGuardTheme();
      }, ms);
    });
  }

  function scheduleLegacyPriceAttempts() {
    var attempts = 0;
    (function tick() {
      if (gnStripMisappliedDpo()) {
        return;
      }
      if (gnPatchDpoPriceSelectors() && window.dpoOptions) {
        gnForceDpoPriceRefresh();
        return;
      }
      if (++attempts < 80) {
        setTimeout(tick, 250);
      }
    })();
  }

  /** Keep stripping while ITORIS re-injects config on premade PDPs. */
  function gnBindPremadeNativeAtc() {
    if (document.documentElement.getAttribute('data-gn-premade-native-atc')) {
      return;
    }
    document.documentElement.setAttribute('data-gn-premade-native-atc', '1');
    document.addEventListener(
      'click',
      function (ev) {
        if (!gnIsPremadeFixedProduct()) {
          return;
        }
        var btn =
          ev.target.closest &&
          ev.target.closest(WAREHOUSE_ATC_CLICK);
        if (!btn) {
          return;
        }
        ev.preventDefault();
        ev.stopImmediatePropagation();
        gnSubmitNativeProductForm(ev);
      },
      true
    );
  }

  function gnSchedulePremadeStripWatch() {
    if (!gnIsPremadeFixedProduct()) {
      return;
    }
    gnBindPremadeNativeAtc();
    gnStripMisappliedDpo();
    if (!document.documentElement.getAttribute('data-gn-premade-strip-observer')) {
      document.documentElement.setAttribute('data-gn-premade-strip-observer', '1');
      var stripping = false;
      var obs = new MutationObserver(function () {
        if (stripping || !gnIsPremadeFixedProduct()) {
          return;
        }
        stripping = true;
        try {
          gnStripMisappliedDpo();
        } finally {
          stripping = false;
        }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }
    var n = 0;
    var timer = setInterval(function () {
      gnStripMisappliedDpo();
      if (++n >= 48) {
        clearInterval(timer);
      }
    }, 250);
  }

  function bindWarehouseDpoPatches() {
    // Premade fixed-size products: never attach CTO DPO patches / cart guard.
    if (gnIsPremadeFixedProduct()) {
      gnSchedulePremadeStripWatch();
      if (window.jQuery) {
        jQuery(window)
          .off(
            'dpo_before_initialize.gnWarehouseStorefront dpo_initialized.gnWarehouseStorefront'
          )
          .on('dpo_before_initialize.gnWarehouseStorefront', gnOnDpoBeforeInitialize)
          .on('dpo_initialized.gnWarehouseStorefront', gnOnDpoInitialized);
      } else {
        window.addEventListener('dpo_before_initialize', gnOnDpoBeforeInitialize);
        window.addEventListener('dpo_initialized', gnOnDpoInitialized);
      }
      return;
    }

    gnPatchDpoSelectors();
    gnEnsureDpoAddToCartButton();
    gnBindWarehouseCartGuardTheme();
    gnBindBaseColorVariantSyncTheme();

    if (window.jQuery) {
      // Replace prior price-only namespace + attach full storefront ATC fix.
      jQuery(window)
        .off(
          'dpo_before_initialize.gnWarehousePrice dpo_initialized.gnWarehousePrice ' +
            'dpo_before_initialize.gnWarehouseStorefront dpo_initialized.gnWarehouseStorefront'
        )
        .on('dpo_before_initialize.gnWarehouseStorefront', gnOnDpoBeforeInitialize)
        .on('dpo_initialized.gnWarehouseStorefront', gnOnDpoInitialized);
      jQuery(document)
        .off('change.gnWarehousePrice keyup.gnWarehousePrice')
        .on(
          'change.gnWarehousePrice keyup.gnWarehousePrice',
          '#itoris_dynamicproductoptions input, #itoris_dynamicproductoptions select',
          gnForceDpoPriceRefresh
        );
    } else {
      // Vanilla fallback — ITORIS normally fires jQuery events; retries still cover ensure.
      window.addEventListener('dpo_before_initialize', gnOnDpoBeforeInitialize);
      window.addEventListener('dpo_initialized', gnOnDpoInitialized);
    }

    gnScheduleLatePaintRetries();
    scheduleLegacyPriceAttempts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindWarehouseDpoPatches);
  } else {
    bindWarehouseDpoPatches();
  }
})();
